function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M22.55 10.49V7.533c0-4.016-3.268-7.283-7.283-7.283-4.016 0-7.283 3.267-7.283 7.283v2.956C5.7 12.51 4.25 15.452 4.25 18.733c0 6.074 4.942 11.017 11.017 11.017 6.074 0 11.017-4.942 11.017-11.017-.001-3.281-1.451-6.223-3.734-8.243zM9.483 7.533a5.79 5.79 0 015.783-5.783 5.79 5.79 0 015.783 5.783v1.841a10.936 10.936 0 00-5.783-1.658c-2.122 0-4.1.614-5.783 1.658V7.533zm5.784 20.717c-5.248 0-9.517-4.27-9.517-9.517 0-5.248 4.269-9.517 9.517-9.517 5.247 0 9.517 4.269 9.517 9.517-.001 5.247-4.27 9.517-9.517 9.517zm.75-11.383V20.6a.75.75 0 01-1.5 0v-3.732a.75.75 0 011.5-.001z"
})));